import {
  queryConfig,
  queryField,
  save,
} from '@/services/down/ignoreStockBinUsageConfig';

export default {
  namespace: 'ignoreStockBinUsageConfig',
  state: {},

  effects: {
    *queryConfig({ payload, callback }, { call, put }) {
      const response = yield call(queryConfig, payload);
      if (callback) callback(response);
    },
    *queryField({ payload, callback }, { call, put }) {
      const response = yield call(queryField, payload);
      if (callback) callback(response);
    },
    *save({ payload, callback }, { call, put }) {
      const response = yield call(save, payload);
      if (callback) callback(response);
    },
  },

  reducers: {
    success(state, action) {
      return {
        ...state,
        data: action.payload,
      };
    },
  },
};
